module.exports = __webpack_public_path__ + "img/character-5.c34e9525.png";